import React from "react";
import {Modal} from "react-bootstrap";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import styles from "./ModalTutorial.module.css"
import arrowCurved from "../../images/arrowCurved.svg"

export default ({open, onClose}) => {

    return <Modal className={`${styles.modal}`} show={open} onHide={onClose}>
        <Modal.Body>
            <div className={`d-flex justify-content-end`}>
                <FontAwesomeIcon onClick={onClose} className={`${styles.closeIcon}`} icon={solid('close')} size={`1x`}/>
            </div>
            <span className={`d-flex justify-content-center font-weight-bold ${styles.text}`}>
                ¡Haz click en los productos para añadirlos a tu lista!
            </span>
            <img className={`${styles.imagen}`} src={arrowCurved} />
        </Modal.Body>
    </Modal>
}
